export default "__VITE_ASSET__Cl0YkHcV__"